import GithubSlugger from "github-slugger";

export const DOCS_BASE = `${process.env.PUBLIC_URL || ""}/docs`;
export const docUrl = (path) => `${DOCS_BASE}/${path}`;

export async function fetchText(path) {
  const res = await fetch(docUrl(path), { cache: "no-cache" });
  const text = await res.text();
  if (!res.ok || /^\s*<!doctype html/i.test(text)) {
    throw new Error(`Dokument nije pronađen: ${path}`);
  }
  return text;
}

export const flattenDocs = (manifest) =>
  manifest.groups.flatMap((g, gi) =>
    g.docs.map((d) => ({ ...d, groupId: g.id, groupTitle: g.title, groupIndex: gi })),
  );

const plainHeading = (s) =>
  s
    .replace(/`([^`]*)`/g, "$1")
    .replace(/\*\*([^*]*)\*\*/g, "$1")
    .replace(/\*([^*]*)\*/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .trim();

export function extractHeadings(markdown) {
  const slugger = new GithubSlugger();
  const out = [];
  let fence = false;
  for (const line of markdown.split("\n")) {
    if (/^\s*(```|~~~)/.test(line)) {
      fence = !fence;
      continue;
    }
    if (fence) continue;
    const m = /^(#{1,6})\s+(.+?)\s*#*\s*$/.exec(line);
    if (!m) continue;
    const text = plainHeading(m[2]);
    const id = slugger.slug(text);
    if (m[1].length === 2 || m[1].length === 3) out.push({ depth: m[1].length, text, id });
  }
  return out;
}

export const toTestId = (path) => path.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase();

export const LANG_BY_TYPE = { yaml: "yaml", json: "json", py: "python", txt: "bash", md: "markdown" };

export async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Preview iframe can deny clipboard-write; fall back to execCommand.
    }
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  document.body.removeChild(ta);
}

export const formatSize = (text) => {
  const bytes = new Blob([text]).size;
  return bytes < 1024 ? `${bytes} B` : `${(bytes / 1024).toFixed(1)} KB`;
};
